import { useRef, useEffect } from 'react'
import gsap from 'gsap'

const Accordion = ({
  isOpen = false,
  className,
  children,
}) => {
  const $root = useRef()
  const $rootBounds = useRef()

  useEffect(() => {
    $rootBounds.current = $root.current.getBoundingClientRect()
    gsap.set($root.current, { height: 0 })
  }, [])

  useEffect(() => {
    if (isOpen) {
      gsap.to($root.current, {
        height: $rootBounds.current.height,
      })
    } else {
      gsap.to($root.current, {
        height: 0,
      })
    }
  }, [isOpen])

  return (
    <div
      ref={$root}
      className={className}
      style={{ overflow: 'hidden' }}
    >
      {children}
    </div>
  )
}

export default Accordion
